/**
* Created by lobin on 2020/6/18.
*/
<template>
  <a-row :gutter="16">
    <a-col :span="5">
      <a-card :body-style="{padding: '16px 10px'}" :bordered="false" class="cabinet">
        <station-select @select="stationSelect" />
      </a-card>
    </a-col>
    <a-col :span="19">
      <a-card :body-style="{padding: '24px'}" :bordered="false" class="cabinet">
        <div class="search-form" slot="title">
          <a-form-model :model="searchForm" layout="inline" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }" style="text-align: right;">
            <a-form-item style="margin-left: 0;float: left">
                <a-button-group>
                    <a-button
                        type="primary"
                        icon="plus"
                        @click="showAdd"
                        :disabled="searchForm.stationId === ''">单个</a-button>
                    <a-button
                        type="primary"
                        icon="plus"
                        @click="showMultiAdd"
                        :disabled="searchForm.stationId === ''">批量</a-button>
                    <a-button
                        type="primary"
                        icon="play-circle"
                        @click="openMulti"
                        :disabled="searchForm.stationId === '' || searchForm.cabnum === ''">批量开箱</a-button>
<!--                    <a-button-->
<!--                        type="primary"-->
<!--                        icon="reload"-->
<!--                        @click="showMultiAdd"-->
<!--                        :disabled="searchForm.stationId === ''">刷新状态</a-button>-->
                </a-button-group>
            </a-form-item>
            <a-form-item>
              <a-select
                  @change="getList"
                  v-model="searchForm.cabnum"
                  style="width: 100px"
                  v-if="searchForm.stationId"
                  allowClear>
                <a-select-option
                    :value="item.value"
                    v-for="item in cabnums"
                    :key="item.value">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item style="margin-right: 0">
              <a-radio-group v-model="searchForm.status" @change="getList">
                <a-radio-button :value="item.value" v-for="item in cabinetStatus" :key="item.value">
                  <cabinet-status :status="item.value" />
                  <span v-if="!item.value">{{ item.name }}</span>
                </a-radio-button>
              </a-radio-group>
            </a-form-item>
          </a-form-model>
        </div>
        <a-list size="large">
          <a-list-item
              class="cabinet-item"
              :class="{
                  processing: item.status === '1',
                  error: item.status === '9',
                  warning: item.status === '2',
                }"
              :key="index" v-for="(item, index) in list">
            <a-list-item-meta>
              <a-avatar slot="avatar" size="large" shape="square">
                {{ item.serial }}
              </a-avatar>
              <a slot="title">{{ item.stationId?.name }}</a>
              <span slot="description">
              <!-- 通道组: {{ item.cabnum }}-{{ item.channel }} -->
              {{ item.lastOpenTime ? item.lastOpenTime : '无' }}
              </span>
            </a-list-item-meta>
            <div slot="actions">
              <a-popconfirm
                  title="你确定要开箱么?"
                  ok-text="确定"
                  cancel-text="放弃"
                  @confirm="openCabinet(item._id)">
                <a href="#">开箱</a>
              </a-popconfirm>
            </div>
            <div slot="actions">
              <a-dropdown>
                <a-menu slot="overlay">
                  <a-menu-item key="1" @click="showModify(item)">
                    <a-icon type="edit" />修改
                  </a-menu-item>
                  <a-menu-item
                      key="2"
                      @click="recoverCabinet(item)"
                      :disabled="item.status === '1'"
                  >
                    <a-icon type="undo" />恢复
                  </a-menu-item>
                </a-menu>
                <a>更多<a-icon type="down"/></a>
              </a-dropdown>
            </div>
            <div class="list-content">
              <div class="list-content-item">
                <span>规格：{{ item.type }}</span>
              </div>
            </div>
            <div class="list-content">
              <div class="list-content-item">
                <cabinet-status :status="item.status" />
              </div>
            </div>
            <div class="list-content">
              <div class="list-content-item">
              通道组:{{ item.cabnum }}-{{ item.channel }}
                <!-- <span>最后开箱时间: {{ item.lastOpenTime ? item.lastOpenTime : '无' }}</span> -->
                <!-- <span>锁状态：</span>
                <a-icon type="lock" v-if="item.lockStatu === 0" style="color: red" />
                <a-icon type="unlock" v-else style="color: green" /> -->
              </div>
            </div>
            <div class="list-content">
              <div class="list-content-item">
                <span>快递：</span>
                <a-tag color="#87d068" v-if="item.canuse">无</a-tag>
                <a-tag color="#108ee9" v-else>有</a-tag>
              </div>
            </div>
            <div class="list-content">
              <div class="list-content-item">
                <span>备注: {{ item.desc ? item.desc : '无' }}</span>
              </div>
              <!-- <div class="list-content-item">
                <span>最后开箱时间: {{ item.lastOpenTime ? item.lastOpenTime : '无' }}</span>
              </div> -->
            </div>
          </a-list-item>
        </a-list>
        <div style="text-align: center">
          <a-pagination :default-current="1" :total="pager.total" :pageSize="pager.pageSize" @change="pagerChange"/>
        </div>
      </a-card>
    </a-col>
    <cabinet-add ref="cabinetAdd" @cancel="getList" />
    <add-and-modify ref="addAndModify" :stationId="searchForm.stationId" @close="getList" />
    <a-modal
      title="输入参数"
      :visible="optionvisible"
      @ok="handOptionOk"
      @cancel="optionvisible = false"
    >
      <a-form-model
        layout="horizontal"
        :model="formOption"
        :label-col="{ span: 4 }"
        :wrapper-col="{ span: 20 }"
      >
        <a-form-model-item label="柜子类型">
          <a-radio-group v-model="formOption.type">
            <a-radio-button value="normal">
              常见类型
            </a-radio-button>
            <a-radio-button value="mini">
              20格迷你
            </a-radio-button>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="柜子数量">
          <a-input-number v-model="formOption.num" :min="1" :max="20" />
        </a-form-model-item>
        <a-form-model-item label="起始组号">
          <a-input-number v-model="formOption.cabstart" :min="1" :max="20" />
        </a-form-model-item>
        <a-form-model-item label="起始编号">
          <a-input-number v-model="formOption.start" :min="1" :max="500" />
        </a-form-model-item>
        <a-form-model-item label="顺序">
          <a-radio-group v-model="formOption.sort">
            <a-radio-button value="normal">
              从左到右
            </a-radio-button>
            <a-radio-button value="reverse">
              从右到左
            </a-radio-button>
          </a-radio-group>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-row>
</template>

<script type="text/babel">
import { mapActions, mapState, mapGetters } from 'vuex';
import { stationCabnums } from '@/api/station';
import {
  createCabinet, cabinetList, openbox, modify,
} from '@/api/cabinet';
import CabinetAdd from './add.vue';
import addAndModify from './addAndModify.vue';

export default {
  components: { CabinetAdd, addAndModify },
  data() {
    return {
      listloading: false,
      searchForm: {
        stationId: '',
        status: '',
        cabnum: '',
        pageSize: 10,
        page: 1,
      },
      visible: true,
      cabnums: [],
      list: [],
      optionvisible: false,
      pager: {
        pageSize: 10,
      },
      formOption: {
        type: 'normal',
        num: 1,
        cabstart: 1,
        start: 1,
        sort: 'normal',
      },
    };
  },
  computed: {
    ...mapState({

    }),
    ...mapGetters(['cabinetStatus']),
  },
  created() {
    this.getList();
  },
  methods: {
    ...mapActions(['getStationList']),
    showMultiAdd() {
      // this.$refs.cabinetAdd.show(this.searchForm.stationId);
      this.optionvisible = true;
    },
    handOptionOk() {
      this.$refs.cabinetAdd.show(this.searchForm.stationId, this.formOption);
      this.optionvisible = false;
    },
    showAdd() {
      this.$refs.addAndModify.show();
    },
    showModify(item) {
      this.$refs.addAndModify.show(item);
    },
    async openCabinet(id) {
      const { data: { success, msg } } = await openbox(id);
      if (success) {
        this.$message.success(msg);
      } else {
        this.$message.error(msg);
      }
    },
    handleButtonClick() {},
    handleMenuClick() {},
    stationSelect(stationId) {
      this.searchForm.stationId = stationId;
      this.getStationCabnums();
      this.getList();
    },
    async getStationCabnums() {
      const { data } = await stationCabnums(this.searchForm.stationId);
      this.cabnums = data;
    },
    async create() {
      const { data } = createCabinet();
      if (data) {
        this.$message.success('添加成功');
      }
    },
    // go(param) {
    //   const { name, query } = this.$route;
    //   this.$router.push({name, query: {...param, ...query}});
    // },
    async getList() {
      this.listloading = true;
      const { data: { docs, pager } } = await cabinetList(this.searchForm);
      this.list = docs;
      this.pager = {
        ...pager,
        showTotal: (total) => `共计 ${total} 条信息`,
      };
      this.listloading = false;
    },
    pagerChange(page) {
      this.searchForm.page = page;
      this.getList();
    },
    async recoverCabinet(item) {
      // eslint-disable-next-line no-underscore-dangle
      await modify(item._id, { status: 1 });
      this.$message.success('操作成功');
      this.getList();
    },
    openMulti() {
      this.$confirm({
        title: '确认',
        content: `确定要批量开第${this.searchForm.cabnum}组的格子吗？`,
        okText: '确认',
        cancelText: '取消',
        onOk: async () => {
          this.openMultiAction();
        }
      });
    },
    async openMultiAction() {
      const { data: { docs, pager } } = await cabinetList({
        stationId: this.searchForm.stationId,
        cabnum: this.searchForm.cabnum,
        pageSize: 1000,
        page: 1,
      });
      for (let i = 0; i < docs.length; i += 1) {
        await this.openCabinet(docs[i]._id);
      }
    }
  },
};

</script>

<style lang="less" rel="stylesheet/less">
.cabinet {
  .ant-avatar{
    font-size: 20px;
  }
  &-item{
    .ant-avatar{
      background: rgba(0,0,0,.09);
    }
    &.processing{
        .ant-avatar{
          background: rgb(135, 208, 104);
        }
    }
    .warning{
      .ant-avatar{
        background: #faad14;
      }
    }
    &.error{
      .ant-avatar{
        background: #f5222d;
      }
    }
  }
}
.list-content-item {
  color: rgba(0, 0, 0, .45);
  display: inline-block;
  vertical-align: middle;
  font-size: 14px;
  margin-left: 40px;
  span {
    line-height: 20px;
  }
  p {
    margin-top: 4px;
    margin-bottom: 0;
    line-height: 22px;
  }
}
</style>
